<div class="row">
  <div class="col-12">
    <h1>Service Log Details</h1>
  </div>
</div>
<div class="form-row mt-2">
  <div class="col-12">
    <a routerLink="/servicelogs" class="btn btn-default">Back</a>
    <button class="btn btn-default"><i class="fal fa-angle-left mr-2"></i> View Previous</button>
    <button class="btn btn-default">View Next <i class="fal fa-angle-right ml-2"></i></button>
  </div>
</div>

<!--<div class="spinner spinner-sm" *ngIf="profileLoading">
  <div class="lspinner"></div>
</div>-->


<div class="row mt-4">
  <div class="col-12">
    <div class="card bg-light">
      <div class="card-body">
        <dl class="dl-horizontal">
          <dt>URL: </dt>
          <dd>{{fullLog.url}}</dd>
          <dt>Response Code: </dt>
          <dd>{{fullLog.responseCode}}</dd>
          <!--<dd class="text-danger">400 - Bad Request</dd>-->
          <dt>Duration: </dt>
          <dd>{{fullLog.responseDurationMs}}</dd>
          <dt>Trace ID: </dt>
          <dd>{{fullLog.traceId}}</dd>
          <dt>Response Date/Time: </dt>
          <dd>{{fullLog.responseDateTime}}</dd>
        </dl>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="card bg-light">
      <div class="card-header">
        <h3 class="m-0">Response Data</h3>
      </div>
      <div class="card-body">
        <dl class="dl-horizontal">
          <dd>{{fullLog.responsePayload}}</dd>
        </dl>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="card bg-light">
      <div class="card-header">
        <h3 class="m-0">Request Data</h3>
      </div>
      <div class="card-body">
        <dl class="dl-horizontal">
          <dd>{{fullLog.requestPayload}}</dd>
        </dl>
      </div>
    </div>
  </div>
</div>
<div class="form-row mt-2">
  <div class="col-12">
    <a routerLink="/servicelogs" class="btn btn-default">Back</a>
    <button class="btn btn-default"><i class="fal fa-angle-left mr-2"></i> View Previous</button>
    <button class="btn btn-default">View Next <i class="fal fa-angle-right ml-2"></i></button>
  </div>
</div>
